import React from 'react';
import { Box } from 'src/components/Box';
import { Card } from 'src/components/Card';
import { Loading } from 'src/components/Loading';
import { Margins, Responsive } from 'src/design-system/style-types';

interface Props {
  height?: Responsive<string>;
  marginBottom?: Responsive<Margins>;
}

export const LoadingCard = ({ height = '400px', marginBottom = 'lg' }: Props) => (
  <Card padding="0" marginBottom={marginBottom}>
    <Box h={height} a="center">
      <Loading />
    </Box>
  </Card>
);
